import React,{useEffect, useState} from 'react'
import Header from './Header'
import Footer from './Footer'
import car from '../assets/car.png'
import insole from '../assets/insole.png'
import key from '../assets/key.png'
import pet from '../assets/pet.png'
import id from '../assets/card.png'
import logo from '../assets/biglogo.png'
import watch from '../assets/watch.png'
import { listtrackers, sendCart } from '../Logic/index01'
import { useNavigate, useParams } from 'react-router-dom'
import { disPlay, messageDisplay, T } from '../Auth/Util'
import Spinner from "../Logic/Spinner";
import { useFlutterwave, closePaymentModal } from 'flutterwave-react-v3';
import { FaSpinner } from 'react-icons/fa6'
import { CircularProgress } from 'react-loader-spinner'

const Shop = () => {


const {m} = useParams();
 const [qua, setQua] = useState(0);
 const [sumed, setSum] = useState([]);
 const [checkout, setCheckOut] = useState(false);
 const [packages, setPackges] = useState([]);
 const [price, setPrice] = useState(1);
 const [opend, setOpend] = useState(false);
 const [total, setTotal] = useState(0);
 const [items, setItems] = useState([]);
 const [loading, setLoading] = useState([]);
 const [prcoessPay, setprcoessPay] = useState(false);
 const histroy = useNavigate();


function increase(i){
    up();
     setQua(qua+1)
 }



function decrease(i){
    up();
    if(qua >= 1){
      setQua(qua-1)
    }
 }



 function purchase(item){
  up();
    setPrice(item.price)
     setPackges(item.ty)
        setQua(0);
            if(!opend){
              setOpend(true)
            }else{
                setOpend(false)
       }
 }




 const up = () => {
     window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth' 
    });
}




  function add(){
    if(price * qua != 0){
      var val = {ty:packages,cost:(price * qua),quantity:qua}
      setOpend(false)
      setSum([...sumed, val]);
      setQua(0);
      setPackges("");
      setPrice(0);  
    }else{
        setOpend(false);
        messageDisplay("Nothing was addee to cart",1);  
    }  
 }




const sendOff = async () => {
    up();
    if(!opend){
        setCheckOut(true);
    }else{
        setCheckOut(false)
    }  
    
 }



 


 function sendPurchase(n){
      let count = 0;
      sumed.filter(num => count = count+num.cost);
      setTotal(count);
      if(n == 0){
        let res = sendCart(sumed,m); //pass total instead of cart list
          if(res){
             setprcoessPay(false)
          }
     }
 }





const config = {
        public_key: process.env.REACT_APP_FLUTTERWAVE, 
        tx_ref: Date.now().toString(),
        amount: total,
        currency: 'NGN',
        payment_options: 'card,banktransfer,ussd',
        customer: {
        email: process.env.REACT_APP_EMAIL,
        phone_number: process.env.REACT_APP_PHONE_NO,
        name: 'Beeppee',
        },
        customizations: {
            title: 'My Tracker checkout',
            description: 'Payment for items in cart',
            logo: process.env.REACT_APP_BEEPPEE_LOGO,
        },
    };

    
  const fwConfig = {
        ...config,
        text: 'Pay with Flutterwave',
        callback: (response) => {
        console.log('Payment successful:', response);
        //Verify the transaction on backend before delivering the product
        closePaymentModal(); 
        },
         onClose: () => {
          messageDisplay('Payment modal closed',1)
        },
    };

  const handleFlutterPayment = useFlutterwave(fwConfig);



  const sendItemsProcess = () => {
      setprcoessPay(true);
       handleFlutterPayment({
        callback: (response) => {
          console.log(response);
          closePaymentModal();
          //sendPurchase(0);
        },
       onClose: (err) => {
        console.log('Payment closed:', err);
        m !== "0" ? sendPurchase(0) : console.log();
      },
    });
  }



const addItemToEnd = () => {
 
      const newItem = {Id:99,
                      m1:"Contact our team for a customised solution.",
                      m2:"Custom service available",
                      price:"",
                      ty:"n/a",
                      url:logo};
      setItems(prevItems => [...prevItems, newItem]);
  
};

  
  useEffect(() => {
      setLoading(true);
        listtrackers()
        .then((v) => {
          if(v != undefined){
                setItems(v);        
                addItemToEnd();
                setLoading(false);
              }else{
                  messageDisplay("Store is down, try again later",1) 
              }    
        }).catch((err) => {
            messageDisplay(err.toString(),1)
     });
  },[])
 
  return (
   
    items.length <= 0 ?
        <div className="flex justify-center items-center  w-full z-50"> 
            <Spinner  color={T.blue}  isloading={loading} h={80} w={80}/>
        </div>  
        :
     <>       
     <div className='sticky top-0 w-full'>  <Header/></div>
       {opend ? <div className='absolute w-full h-full flex justify-center mt-24'>
                     <div className='z-50 h-auto pb-12 self-center flex flex-col bg-white lg:w-1/4 w-full m-5 rounded-lg justify-center border border-primary/50 shadow-xl translate-y-1 '>
                        <div onClick={purchase} className='self-end text-2xl  mt-2 mr-10  cursor-pointer '>X</div>
                        <div className='self-center'>{price * qua == 0 ? price : price * qua }</div>
                            <div className='flex flex-row self-center  justify-evenly w-full'>
                                  <button onClick={() => decrease()}  class="bg-[#0eb1d2] flex w-10 cursor-pointer items-center justify-center rounded-lg h-12 px-6 bg-primary text-white text-base font-bold leading-normal tracking-[0.015em] hover:shadow-lg hover:text-blue-500 transition-shadow">
                                     -
                                   </button>
                                 <span className='self-center'>{qua}</span> 
                                  <button onClick={() => increase()}  class="bg-[#0eb1d2] flex w-10 cursor-pointer items-center justify-center rounded-lg h-12 px-6 bg-primary text-white text-base font-bold leading-normal tracking-[0.015em] hover:shadow-lg hover:text-blue-500 transition-shadow">
                                     +
                                   </button>
                                
                              </div>
                            <button onClick={() =>  add()}  class="bg-[#0eb1d2]  flex w-1/2 m-10 self-center cursor-pointer items-center justify-center rounded-lg h-10 px-6 bg-primary text-white text-base font-bold leading-normal tracking-[0.015em] hover:shadow-lg hover:text-blue-500 transition-shadow">
                                      add
                             </button>
                             
                        </div>
                  </div>
                : null}


              {checkout ? <div className='absolute w-full h-full flex justify-end'>
                        <div className='z-50 self-end h-full flex flex-col bg-white w-full lg:w-1/4 rounded-lg border border-gray-100/90 p-4'>
 
                            <div onClick={(e) => setCheckOut(false)} className='self-end text-lg m-5 justify-center cursor-pointer'>X</div>
                                 {sumed.map((v,i) =><table>
                                                      <br/>
                                                      <tr>
                                                          <td>
                                                          Tracker: {v.ty}
                                                          </td> 
                                                      </tr>
                                                      <tr>
                                                          <td>
                                                          SubTotal: {v.cost}
                                                          </td> 
                                                      </tr>
                                                      <tr>
                                                          <td>
                                                          Quantity: {v.quantity}
                                                          </td> 
                                                      </tr>   
                                                  </table>
                                          )}
                                <h5 className='self-center mt-5'>Total: {total}</h5>
                                {/**<InterswitchPay className='self-center mt-10' {...paylaod}/>**/}
                                <div className="checkout-container flex">
                                    <button
                                        className='w-full h-10 p-2 mt-12 self-center bg-blue-700 text-white  flex justify-center'
                                         onClick={() => { m === "0" ? messageDisplay("Pls download beeppee app to process payment.",1) : sendItemsProcess()
                                        }}>   
                                       {prcoessPay ? <div className='flex self-center'> <CircularProgress  width={20} height={20} color={T.greenText} /> </div> : "Pay Now" }
                                    </button>
                                    </div>
                            </div> 
                  </div>
                : null}


               <main class="flex-1 flex flex-col items-center mt-20">
                <div class="w-full max-w-[1200px] px-4 md:px-10 py-10">
                <div class="mb-6">
                <h2 class="text-[#0d191c]  text-3xl font-extrabold leading-tight tracking-tight">Beeppee Trackers Shop</h2>
                <p class="text-slate-500  mt-2 text-lg">Premium tracking solutions for everything you love.</p>
                </div>
               
                <div class="flex gap-3 py-4 flex-wrap overflow-x-auto no-scrollbar">
                <button class="flex h-10 shrink-0 items-center justify-center gap-x-2 rounded-full bg-white text-slate-700 px-6 font-semibold border-slate-200 shadow-sm shadow-primary/40">
                  <p class="text-sm">All Trackers</p>
                </button>
                <button class="flex h-10 shrink-0 items-center justify-center gap-x-2 rounded-full bg-white  border border-slate-200 dark:border-slate-200 px-6 font-medium text-slate-700 dark:text-slate-300 hover:border-primary transition-all">
                    <span class="material-symbols-outlined text-price-cyan text-[20px]">directions_car</span>
                    <p class="text-sm">Automobile</p>
                </button>
                <button class="flex h-10 shrink-0 items-center justify-center gap-x-2 rounded-full bg-white border border-slate-200 dark:border-slate-200 px-6 font-medium text-slate-700 dark:text-slate-300 hover:border-primary transition-all">
                    <span class="material-symbols-outlined text-price-cyan text-[20px]">person_check</span>
                    <p class="text-sm">People</p>
                </button>
                <button class="flex h-10 shrink-0 items-center justify-center gap-x-2 rounded-full bg-white  border border-slate-200 dark:border-slate-200 px-6 font-medium text-slate-700 dark:text-slate-300 hover:border-primary transition-all">
                    <span class="material-symbols-outlined text-price-cyan text-[20px]">pets</span>
                    <p class="text-sm">Pets</p>
                </button>
                    <button class="flex h-10 shrink-0 items-center justify-center gap-x-2 rounded-full bg-white  border border-slate-200 dark:border-slate-200 px-6 font-medium text-slate-700 dark:text-slate-300 hover:border-primary transition-all">
                    <span class="material-symbols-outlined text-price-cyan text-[20px]">key</span>
                    <p class="text-sm">Accessories</p>
                    </button>
                </div>
              

              

                <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 mt-8">
              
                   {items.map((v,i)=>  v.Id === 99 ?
                      <div key={99} class="group flex flex-col bg-white  rounded-xl overflow-hidden border border-slate-200  hover:shadow-xl hover:-translate-y-1 transition-all duration-300">
                            {/* <div class="w-full aspect-[4/3] bg-center bg-contain bg-no-repeat" data-alt="Beeppee trackers" style={{backgroundImage: `url(${v.url})`}}></div> */}
                            <div style={{display:"flex", width: '100%', height: '200px', textAlign:"center", justifyContent:"center", alignItems:"center", }}>
                                   <img  loading='lazy' alt='beepy logo'  className='object-contain' style={{maxWidth: '300px', // Forces the image to shrink/reduce size
                                         height: '140px'}}  src={v.url}/>
                            </div>
                           
                            <div class="p-5 flex flex-col flex-grow">
                            <div class="flex justify-between items-start mb-2">
                            <h3 class="text-[#0d191c]  text-lg font-bold leading-tight mb-2">{v.price}</h3>
                            </div>
                            <h3 class="text-[#0d191c]  text-lg font-bold leading-tight mb-2">{v.m2}</h3>
                            <p class="text-slate-500  text-sm font-normal leading-relaxed mb-6 flex-grow">
                                {v.m1}
                            </p>
                            <button onClick={(e) =>{
                               histroy("/contact");
                                up();
                            }} class="w-full bg-[#ff7ebc] active:scale-95 text-white font-bold py-3 rounded-lg flex items-center justify-center gap-2 transition-all shadow-lg shadow-cta-pink/20">
                                <span class="material-symbols-outlined text-[20px]">phone</span>
                                      Contact Us
                            </button>
                      </div>
                     
                    </div>
                   :
                   <div key={i} class="group flex flex-col bg-white  rounded-xl overflow-hidden border border-slate-200  hover:shadow-xl hover:-translate-y-1 transition-all duration-300">
                            <div class="w-full aspect-[4/3] bg-center bg-cover" data-alt="Beeppee trackers" style={{backgroundImage: v.url === "car" ? `url(${car})` : v.url === "key" ? `url(${key})` : v.url === "pet" ? `url(${pet})` : v.url === "insole" ? `url(${insole})` : v.url === "watch" || v.url === "Watch" ?  `url(${watch})` :  `url(${id})`}}></div>
                            <div class="p-5 flex flex-col flex-grow">
                            <div class="flex justify-between items-start mb-2">
                            <p class="text-price-cyan text-xl font-bold text-slate-700">{v.price}</p>
                            </div>
                            <h3 class="text-[#0d191c]  text-lg font-bold leading-tight mb-2">{v.m1}</h3>
                            <p class="text-slate-500  text-sm font-normal leading-relaxed mb-6 flex-grow">
                                {v.m2}
                            </p>
                            <button onClick={(e) => purchase(v)} class="w-full bg-[#ff7ebc] active:scale-95 text-white font-bold py-3 rounded-lg flex items-center justify-center gap-2 transition-all shadow-lg shadow-cta-pink/20">
                                <span class="material-symbols-outlined text-[20px]">shopping_bag</span>
                                      Buy now
                            </button>
                      </div>
                     
                    </div>
                    )}

                </div>


                <div className='w-full flex justify-center'>
                      <button disabled={sumed.length > 0 ? false : true} onClick={() =>{ sendPurchase(1); sendOff()}}  class="bg-[#0eb1d2] flex w-28 p-4 h-12 lg:w-1/6 m-10 self-center cursor-pointer items-center justify-center rounded-lg  bg-primary text-white text-base font-bold leading-normal tracking-[0.015em] hover:shadow-lg  transition-shadow
                      hover:bg-white disabled:bg-gray-400 disabled:text-gray-200 disabled:cursor-not-allowed ">
                         Proceed
                    </button>
                </div>
                  


                <div class="mt-20 grid grid-cols-1 md:grid-cols-3 gap-8 p-10 bg-primary/5 rounded-2xl border border-primary/10">
                <div class="flex flex-col items-center text-center gap-3">
                <div class="w-12 h-12 bg-slate-600 rounded-full flex items-center justify-center text-white">
                <span class="material-symbols-outlined">local_shipping</span>
                </div>
                <h4 class="font-bold text-lg">Fast Delivery</h4>
                <p class="text-slate-500 text-sm">Free shipping on all orders over $100 across the country.</p>
                </div>
                <div class="flex flex-col items-center text-center gap-3">
                <div class="w-12 h-12 bg-[#ff23b9] rounded-full flex items-center justify-center text-white">
                <span class="material-symbols-outlined">security</span>
                </div>
                <h4 class="font-bold text-lg">Safe Payments</h4>
                <p class="text-slate-500 text-sm">Your data and payments are protected by 256-bit encryption.</p>
                </div>
                <div class="flex flex-col items-center text-center gap-3">
                <div class="w-12 h-12 bg-[#1658EA] rounded-full flex items-center justify-center text-white">
                <span class="material-symbols-outlined">support_agent</span>
                </div>
                <h4 class="font-bold text-lg">24/7 Support</h4>
                <p class="text-slate-500 text-sm">Our experts are available anytime to help you with setup.</p>
                </div>
                </div>
                </div>
         </main>  
         <Footer/>    
    </>
  )
}

export default Shop
